module.exports = __webpack_public_path__ + "static/KioskHealth-c45a0aaf6781bc403b0b0bc0576cdd7d.png";